import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=49155ba4&scoped=true&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"
import style0 from "./Child.vue?vue&type=style&index=0&id=49155ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49155ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49155ba4')) {
      api.createRecord('49155ba4', component.options)
    } else {
      api.reload('49155ba4', component.options)
    }
    module.hot.accept("./Child.vue?vue&type=template&id=49155ba4&scoped=true&", function () {
      api.rerender('49155ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/PersonalData/Child.vue"
export default component.exports